import { useTranslation } from 'react-i18next';
import dayjs from 'dayjs';

import { MplButton, MplModal } from '@mopla/ui';
import { ValidityWarning } from '@mopla/ui/icons/ValidityWarning';

interface IValidityModal {
	isOpen: boolean;
	onSubmit: () => void;
	onCancel: () => void;
}

/**
 * TODO: redesign-dticket remove this component after new subscription flow is implemented
 * @deprecated
 */
export const ValidityModal = ({
	isOpen,
	onSubmit,
	onCancel,
}: IValidityModal) => {
	const { t } = useTranslation(['dticket']);
	const daysToEndOfMonth = dayjs().endOf('month').diff(dayjs(), 'day') + 1;
	const currentMonthTitle = dayjs().format('MMMM');

	return (
		<MplModal
			open={isOpen}
			icon={<ValidityWarning />}
			title={t('dticket:subscription_management.modal.header.validity_header', {
				count: daysToEndOfMonth,
			})}
			content={t('subscription_management.modal.validity_description', {
				currentMonthTitle,
			})}
			buttons={
				<>
					<MplButton
						fullWidth
						onClick={onCancel}
						children={t('button.go_back')}
						variant="outlined"
					/>
					<MplButton
						fullWidth
						onClick={onSubmit}
						children={t('button.proceed_anyway')}
					/>
				</>
			}
			testId="dticket-subscription-soon-expiration-modal"
			textAlign="center"
		/>
	);
};
